import React from "react";
import { FLOW_TYPES } from "../../constants/flowType";
import { useTicketingContext } from "../../store";
import { ACTION_TYPES } from "../../store/actionTypes";

const StepperItem = ({ title, isActive, stepIndex, steps }) => {
  const { state, dispatch } = useTicketingContext();

  const { flowType } = state;

  const isStepVisited = steps[stepIndex].isVisited;
  const isPreviousStepValid =
    stepIndex === 0 ? true : steps[stepIndex - 1].isValid;

  const onStepClickhandler = () => {
    if (flowType === FLOW_TYPES.ACTIVITIES_ONLY) {
      return;
    }

    if (isStepVisited && isPreviousStepValid) {
      dispatch({
        type: ACTION_TYPES.SET_ACTIVE_STEP,
        payload: {
          stepToSet: stepIndex,
        },
      });
    }
  };

  const isClickable =
    flowType === FLOW_TYPES.ADMISSION && isStepVisited && isPreviousStepValid;

  return (
    <li
      className={`stepper-item ${isActive ? "active" : ""} ${
        !isClickable ? "not-clickable" : ""
      }`}
      onClick={onStepClickhandler}
    >
      <span className="stepper-item-number">{stepIndex + 1}.</span>
      <span className="stepper-item-label">&nbsp;{title}</span>
    </li>
  );
};

export default React.memo(StepperItem)